import { SanityImageObject } from '@sanity/image-url/lib/types/types';
import { imageDimensions, imageUrl } from 'api';
import Image from 'next/image';
import { FC, useMemo } from 'react';

type ImageWrapperProps = {
  image: SanityImageObject & {
    localMedia?: string;
  };
  alt?: string;
};

const ImageWrapper: FC<ImageWrapperProps> = ({ image, alt }) => {
  const style = useMemo(() => {
    const { aspectRatio } = imageDimensions(image);

    return { aspectRatio };
  }, [image]);

  return (
    <div className="relative" style={style}>
      <Image
        alt={alt || ''}
        src={imageUrl(image).toString()}
        fill
        className="object-contain"
      />
    </div>
  );
};

export default ImageWrapper;
